import React from 'react';

import './CompetitionStatus.scss';

export const CompetitionStatus = ({ text, contentClass = '', showText = true }) => (
  <div className={`status status-competition status-${text?.toLowerCase().replace(/\s/g, '')} ${contentClass}`}>
    <span>{showText ? text : ''}</span>
  </div>
);
